import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Hiển thị thông báo lỗi cho người dùng
          alert('Bạn chưa đăng nhập hoặc phiên đăng nhập của bạn đã hết hạn. Vui lòng đăng nhập lại.');

          // Chuyển hướng đến trang đăng nhập
          this.router.navigate(['/Login']);
        }
        return throwError(error);
      })
    );
  }
}
